export default __webpack_public_path__ + "static/media/plus.d2b3cd7f.svg";